import { HistoryItemType } from '@alberta/konexi-shared';
import ChangeOperation from '@alberta/konexi-shared/dist/general/enum/change-operation';
import IIntegratedCareHistoryLine from '@alberta/konexi-shared/dist/product/integrated-care-history-line';
import { IIntegratedCareHistoryArticle } from 'src/app/shared/models/integrated-care/integrated-care-history-article.model';
import { v4 } from 'uuid';

export class IntegratedCareHistoryLineViewModel implements IIntegratedCareHistoryLine {
  date: Date;
  userName: string;
  userId: string;
  changeOperation: ChangeOperation;
  valueBefore: any;
  valueAfter: any;
  articleId: string;
  /** Stammdaten des Artikels beim Schreiben des Eintrags, siehe {@link IIntegratedCareHistoryArticle}. */
  article?: IIntegratedCareHistoryArticle;
  key: string;
  _id: string;
  timestamp: Date;
  archived: boolean;

  constructor(public type: HistoryItemType) {
    this._id = v4();
    this.date = this.timestamp = new Date();
    this.archived = false;
  }
}
